import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    loading: "idle",
    flag: null,
    responseTitle: null,
    responseDescription: null,
    error: null,
    info: {},
    isPopup: false
};
const responseSlice = createSlice({
    name: "response",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setFlag: (state, action) => {
            state.flag = action.payload;
        },
        setResponseTitle: (state, action) => {
            state.responseTitle = action.payload;
        },
        setResponseDescription: (state, action) => {
            state.responseDescription = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setResponseInfo: (state, action) => {
            state.info = action.payload;
        },
        setIsPopup: (state, action) => {
            state.isPopup = action.payload;
        },
        resetResponseState: (state) => {
            state = { ...initialState };
        }
    },
    extraReducers: (builder)=>{

    }
})

export const { setLoading, setFlag, setResponseTitle, setResponseDescription, resetResponseState, setIsPopup, setResponseInfo} = responseSlice.actions;
export default responseSlice.reducer;